<ic-auth-wrapper contentBoxPadding="32px" width="52rem" [isCenteredLogo]="false">
	@if (loadingInstructions$ | async) {
		<spinner class="spinner" />
	}
	@if (connectionFailed$ | async) {
		<div class="connectionFailed">
			<i class="fa fa-times-circle"></i>
			<p>
				{{ "auth.errors.unknown" | translate }}
			</p>
			<ui-double-button
				class="try-again-btn"
				icon="fa fa-refresh"
				type="primary"
				[loading]="refreshing$ | async"
				(action)="refreshPage()"
			>
				{{ "actions.refresh" | translate }}
			</ui-double-button>
		</div>
	}
	@if (showInstructions$ | async) {
		<div class="user-settings">
			<div class="mfa-content">
				<h1 class="title-default">{{ "auth.mfa" | translate }}</h1>
				<div class="mfa-box">
					<div class="qrcodeImage">
						<qrcode data-test="qrcode-image" errorCorrectionLevel="M" [qrdata]="stringQrCode" [width]="200" />
					</div>
					<div class="code-button" data-test="show-code-button">
						@if (showCode) {
							<p data-test="secret-code">{{ secretCode }}</p>
						} @else {
							<a (click)="showCode = true">
								{{ "auth.mfa_instructions.show_code" | translate }}
							</a>
						}
					</div>
					<div class="double-input">
						<ic-label (click)="onLabelClick()">
							{{ "auth.mfa_instructions.secret_code" | translate }}
						</ic-label>
						<code-input
							#codeInput
							data-test="mfa-token-input"
							[codeLength]="6"
							[initialFocusField]="0"
							[isCodeHidden]="false"
							(codeChanged)="onCodeChanged($event)"
							(codeCompleted)="onCodeCompleted($event)"
						/>
						@if (codeRequired) {
							<p class="errors">{{ "auth.errors.mfa_required" | translate }}</p>
						}
						@if (invalidCode | async) {
							<p class="errors">{{ "auth.errors.mfa_invalid" | translate }}</p>
						}
						@if (toShortCode | async) {
							<p class="errors">{{ "auth.errors.mfa_to_short_code" | translate }}</p>
						}
					</div>
					<div class="buttons">
						<ui-double-button icon="fa fa-times" type="secondary" [icValidateForms]="[form]" (action)="cancel()">
							{{ "labels.actions.cancel" | translate }}
						</ui-double-button>
						<ui-double-button
							class="save-btn"
							data-test="save-button"
							icon="fa fa-save"
							type="primary"
							[icValidateForms]="[form]"
							[loading]="loadingSuccessful$ | async"
							(action)="validate()"
						>
							{{ "actions.save" | translate }}
						</ui-double-button>
					</div>
				</div>
			</div>
			<div class="divider-vertical"></div>
			<div class="explanation-content">
				<h2>{{ "auth.mfa_instructions.step1.title" | translate }}</h2>
				<ul>
					<li>{{ "auth.mfa_instructions.step1.step1_1" | translate }}</li>
				</ul>
				<h2>{{ "auth.mfa_instructions.step2.title" | translate }}</h2>
				<ul>
					<li>{{ "auth.mfa_instructions.step2.step2_1" | translate }}</li>
					<li>{{ "auth.mfa_instructions.step2.step2_2" | translate }}</li>
					<li>{{ "auth.mfa_instructions.step2.step2_3" | translate }}</li>
					<li>{{ "auth.mfa_instructions.step2.step2_4" | translate }}</li>
				</ul>
				<h2>{{ "auth.mfa_instructions.step3.title" | translate }}</h2>
				<ul>
					<li>{{ "auth.mfa_instructions.step3.step3_1" | translate }}</li>
					<li>{{ "auth.mfa_instructions.step3.step3_2" | translate }}</li>
					<li>{{ "auth.mfa_instructions.step3.step3_3" | translate }}</li>
				</ul>
			</div>
		</div>
	}
	@if (showSuccessful$ | async) {
		<div class="successful-content">
			<h1 class="title-default">{{ "auth.mfa" | translate }}</h1>
			<i class="fa fa-check-circle"></i>
			<p>{{ "auth.mfa_success" | translate }}</p>
			<ui-double-button
				class="goto-btn"
				data-test="goto-login-button"
				icon="fa fa-sign-in"
				type="primary"
				(action)="goToLogin()"
			>
				{{ "auth.signin" | translate }}
			</ui-double-button>
		</div>
	}
</ic-auth-wrapper>
